import { useEffect } from "react";

export const SITE_URL = "https://www.stayguideapp.it";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Lightweight, dependency-free SEO/meta manager for the SPA.
 * All canonical/OG URLs are pinned to the canonical www domain.
 */
export function useSeo({ title, description, path = "/", noindex = false } = {}) {
  useEffect(() => {
    const url = SITE_URL + path;
    if (title) {
      document.title = title;
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    setCanonical(url);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    return () => {
      upsertMeta("name", "robots", "index, follow");
    };
  }, [title, description, path, noindex]);
}
